import { SoundMode } from '../services/ProgressStore';
import { el } from './dom';
import { ICONS, icon } from './icons';

/** Symbol, label and the action of the next tap for each step (the switch cycles All → EffectsOnly → Mute → All). */
const STEPS: Record<SoundMode, { readonly icon: string; readonly label: string; readonly next: string }> = {
  [SoundMode.All]: { icon: ICONS.musicOn, label: 'Musik & Ton: an', next: 'Musik ausschalten' },
  [SoundMode.EffectsOnly]: { icon: ICONS.musicOff, label: 'Nur Spielton', next: 'Ton ganz ausschalten' },
  [SoundMode.Mute]: { icon: ICONS.soundOff, label: 'Ton: aus', next: 'Musik und Ton einschalten' },
};

/**
 * Sound button with three steps (music and game sounds, game sounds only, silence) – the same control on the start
 * screen, in the HUD and on the pause screen. The click is the user gesture browsers need to start audio, so the
 * handler switches the sound directly.
 */
export class MusicToggle {
  readonly element: HTMLButtonElement;
  private readonly symbol: HTMLSpanElement;
  private readonly label: HTMLSpanElement | null;

  constructor(parent: HTMLElement, className: string, onToggle: () => void, withLabel = false) {
    this.element = el('button', `music-toggle ${className}`, undefined, parent);
    this.element.type = 'button';
    this.symbol = icon(ICONS.musicOn, 'music-toggle-icon');
    this.element.append(this.symbol);
    this.label = withLabel ? el('span', 'music-toggle-label', undefined, this.element) : null;
    this.element.addEventListener('click', (event) => {
      event.stopPropagation();
      onToggle();
    });
    // The tap must not also count as a gesture of the game (Confirm would start / resume the run).
    this.element.addEventListener('pointerdown', (event) => event.stopPropagation());
    this.setMode(SoundMode.All);
  }

  setMode(mode: SoundMode): void {
    const step = STEPS[mode];
    this.symbol.innerHTML = step.icon;
    this.element.setAttribute('aria-label', step.next);
    this.element.title = step.label;
    this.element.classList.toggle('is-off', mode !== SoundMode.All);
    if (this.label) this.label.textContent = step.label;
  }
}
